const icon = require('vue-svgicon');
icon.register({
    'clock': {
        width: 12,
        height: 12,
        viewBox: '0 0 12 12',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M6 11.333A5.333 5.333 0 116 .667a5.333 5.333 0 010 10.666zm0-10a4.667 4.667 0 100 9.334 4.667 4.667 0 000-9.333zm-.321 5.331h2.987A.333.333 0 009 6.334c0-.183-.15-.33-.335-.33H6v-2.67a.333.333 0 00-.667 0V6.33l-.002.004a.32.32 0 00.07.191.327.327 0 00.271.14.022.022 0 01.007 0z" _fill="#27242D"/>`,
    },
});
